import { createFileRoute, useNavigate, useRouterState } from '@tanstack/react-router'
import { Box, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { styled } from '@mui/system'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useParams } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { PieChart } from '@mui/x-charts/PieChart';
import WarningIcon from '@mui/icons-material/Warning';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


export const Route = createFileRoute('/(dashboard)/_dashboard/history-details/$id')({
  component: RouteComponent,
})

const IconWrapper = styled(Box)(() => ({
    width: '64px',
    height: '64px',
}));

function RouteComponent() {

    // Uzimamo Id intervju
    const {id} = Route.useParams();

    const newState = useRouterState();
    
    // const theme = useTheme()
    // const isMobile = useMediaQuery(theme.breakpoints.down('md'))


    const navigate = useNavigate();
    const [colorOfIcon, setColorOfIcon] = useState('');

    const state = useRouterState().location.state?.interview;
    const percent = state?.totalQuestions
        ? Math.round((state.correctQuestions / state.totalQuestions) * 100)
        : 0

    // const totalTimeInSeconds = state?.totalTime;

    // const minutes = Math.floor(totalTimeInSeconds / 60)
    // const seconds = Math.floor(totalTimeInSeconds % 60)
    // const formatted = `${minutes}:${seconds.toString().padStart(2, '0')}`

    const remainder = 100 - percent;

    const data = [
        { id: 0, value: percent, label: 'Progress' },
        { id: 1, value: remainder, label: 'Remaining' },
    ];

    useEffect(() => {
    if (percent < 50) {
        setColorOfIcon('#F53C2D');
    } else if (percent >= 50 && percent < 80) {
        setColorOfIcon('#FFC107');
    } else {
        setColorOfIcon('#31C07D');
    }
    }, [percent]);


    // Prikupljamo sve kategorije
    const { data: categories} = useQuery({
        queryKey: ['submittedCategories', id],
        queryFn: async () => {
            const token = localStorage.getItem('token');
            const response = await axios.get(
                `https://interviewer.runasp.net/api/submissionInterviews/${id}/results`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        },
    });

    // Odredjujemo boju za kategorije
    const getCategoryBadgeColors = (total: number, correct: number) => {
        if (total === 0) {
            return { background: '#F53C2D26', color: '#F53C2D' };
        }
        const percentage = (correct / total) * 100;

        if (percentage >= 70) {
            return { background: 'var(--Lightest-Green)', color: 'var(--Interviewer-Green)' };
        }

        if (percentage >= 40) {
            return { background: '#FF950026', color: '#FF9500' };
        }

        return { background: '#F53C2D26', color: '#F53C2D' };
    }

    // Prosecno vreme odgovra u sekundama
  const getAvgAnswerTimeInMinutes = (time: number) => {
    if (!time || time <= 0) return '';

    // Pretvori sekunde u minute
    const minutes = time / 60;

    // Zaokruži na jednu decimalu
    const roundedMinutes = Math.round(minutes * 10) / 10;

    return `${roundedMinutes}m`;
}

    const getTotalTimeInMinutes = (totalTime: number) => {
        const minutes = totalTime / 60;

        if (minutes < 1) {
            // Prikaži decimalni minut sa jednom decimalom
            return `${minutes.toFixed(1)}m`;
        } else {
            // Zaokruži na ceo broj minuta
            return `${Math.ceil(minutes)}m`;
        }
    }

    return (
        <Box sx={{
            width: {xs: '100%', md: '80%'},
            mx: 'auto',
            padding: {xs: '20px 16px', md: '75px 75px'}
        }}>
            <Box sx={{mb: '24px'}}>
                <Typography variant="h1">Results Overview</Typography>
            </Box>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(3, 1fr)',
                    lg: 'repeat(4, 1fr)',
                    xl: 'repeat(5, 1fr)',
                    gap: '20px'
                },
            }}>

                {categories?.categoryResults.map((category: any, index: number) => {
                    const colors = getCategoryBadgeColors(category.totalAnswersCount,category.correctAnswersCount)
                    return (
                        <Box
                            onClick={() => {
                                navigate({
                                    to: `/history-category-detail/${id}/${category.submittedCategoryId}`,
                                })
                            }}
                            key={index} 
                            sx={{
                                backgroundColor: '#fff',
                                border: '1px var(--Light-Gray)',
                                borderRadius: '16px',
                                boxShadow: '0px 1px 2px 0px #0205111A',
                                padding: '24px',
                                minHeight: '120px',
                                height: '100%',
                                display: 'flex',
                                ":hover": {
                                    cursor: 'pointer'
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    flexGrow: 1,
                                }}
                            >
                                <Typography sx={{ fontWeight: '600', fontSize: '14px', color: 'var(--Interviewer-Black)'}}>
                                    {category?.submittedCategoryName}
                                </Typography>
                                
                                <Typography
                                    sx={{
                                        background: colors.background,
                                        color: colors.color,
                                        width: '100%',
                                        textAlign: 'center',
                                        borderRadius: '100px',
                                    }}
                                    variant='h3'
                                    >
                                    {category.correctAnswersCount} / {category.totalAnswersCount}
                                </Typography>
                            </Box>
                        </Box>
                    )
                })}

            </Box>
            
            <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'row' },
                    gap: '20px',
                    mt: '20px',
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        padding: '32px',
                        width: {xs: '100%', lg: '60%'},
                        border: '1px var(--Light-Gray)',
                        borderRadius: '16px',
                        boxShadow: '0px 1px 2px 0px #0205111A',
                        display: 'flex',
                        gap: {xs: '20px', lg: '0px'},
                        flexDirection: {xs: 'column', lg: 'row'},
                        justifyContent: 'space-between',
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: {xs: "row", lg: 'column'},
                        justifyContent: 'space-between'
                    }}>
                        <Typography variant='h2'>Overall result</Typography>
                        <Typography variant='h2' sx={{
                            background: 'var(--Lightest-Green)',
                            padding: '6px 14px',
                            borderRadius: '8px',
                            color: 'var(--Interviewer-Green)',
                            fontSize: '14px'
                        }}>23 Questions Answered</Typography>
                    </Box>

                    <Box sx={{position: 'relative'}}>
                        <Stack direction="row">
                            <PieChart
                                width={200}
                                height={200}
                                series={[
                                {
                                    startAngle: -90,
                                    endAngle: 90,
                                    paddingAngle: 0,
                                    innerRadius: 70,
                                    outerRadius: 90,
                                    data,
                                },
                                ]}
                                hideLegend
                                colors={[colorOfIcon, '#F0F1F3']}
                            />
                        </Stack>

                        <Box sx={{
                            position: 'absolute',
                            top: '0%',
                            left: '70%',
                            width: '64px',
                            height: '64px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #fff',
                            borderRadius: '16px',
                            background: 'linear-gradient(145deg, var(--Light-Gray), #ffffff)',
                            boxShadow: '0px 0px 26.07px 0px #0000000D',

                        }}>
                            {colorOfIcon === '#F53C2D' && <CancelIcon sx={{ color: '#F53C2D' }} />}
                            {colorOfIcon === '#FFC107' && <WarningIcon sx={{ color: '#FFC107' }} />}
                            {colorOfIcon === '#31C07D' && <CheckCircleIcon sx={{ color: '#31C07D' }} />}
                        </Box>

                        <Box sx={{
                            position: "absolute",
                            top: "55%",
                            left: "50%",
                            transform: "translate(-50%, -90%)",
                            textAlign: "center",
                        }}
                        >
                            <Typography sx={{ fontWeight: 700, color: colorOfIcon, fontSize: '24px' }}>
                            {percent}%
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#555" }}>
                                Potential hiring rate
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        width: {xs: '100%', lg: '40%'},
                        border: '1px var(--Light-Gray)',
                        borderRadius: '16px',
                        boxShadow: '0px 1px 2px 0px #0205111A',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >   
                    <Box sx={{
                        padding: '20px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Typography variant='h3'>Overall Score</Typography>
                        <Typography sx={{
                            background: 'linear-gradient(308.71deg, #31C07D 0.09%, #47C5FB 100%)',
                            padding: '14px 20px',
                            borderRadius: '8px',
                            color: '#fff',
                            fontSize: '32px'
                        }}>{state?.correctQuestions}/{state?.totalQuestions}</Typography>
                    </Box>
                    <Divider />
                    <Box sx={{
                        padding: '20px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Typography variant='h3'>Total Interview Time</Typography>
                        <Typography sx={{
                            background: 'linear-gradient(308.71deg, #31C07D 0.09%, #47C5FB 100%)',
                            padding: '14px 20px',
                            borderRadius: '8px',
                            color: '#fff',
                            fontSize: '32px'
                        }}>
                            {categories?.totalTime != null && getTotalTimeInMinutes(categories.totalTime)}
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{
                        padding: '20px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Typography variant='h3'>Average Answer Time</Typography>
                        <Typography sx={{
                            background: '#47C5FB1A',
                            padding: '14px 20px',
                            borderRadius: '8px',
                            color: 'var(--Interviewer-Black)',
                            fontSize: '32px'
                        }}>
                            {categories?.avgAnswerTime != null && getAvgAnswerTimeInMinutes(categories.avgAnswerTime)}
                            {/* {getAvgAnswerTimeInMinutes(categories?.avgAnswerTime)}<span style={{fontSize: '16px'}}>m</span> */}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
